import { requestJson } from './requestJson';
import { buildApiUrl } from './apiUrl';

function postLocationStatus(action, payload, accessToken) {
  return requestJson(buildApiUrl('/api/location-status'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ action, ...payload }),
  });
}

export function fetchLocationStatuses(accessToken) {
  return postLocationStatus('getLocationStatuses', {}, accessToken);
}

export function confirmLocationUpToDate(locationScope, accessToken) {
  return postLocationStatus('confirmLocationUpToDate', { locationScope }, accessToken);
}

export function updateLocationStatus(locationScope, status, accessToken) {
  return postLocationStatus('setLocationStatus', { locationScope, status }, accessToken);
}

export function updateUserLocationStatus(targetEmail, locationScope, status, accessToken) {
  return postLocationStatus('setUserLocationStatus', { targetEmail, locationScope, status }, accessToken);
}

export function fetchLocationStatusHistory(locationScope, accessToken, offset = 0, limit = 25) {
  return postLocationStatus('getLocationStatusHistory', { locationScope, offset, limit }, accessToken);
}
